export enum ELang {
  uk = "uk",
  us = "us",
  de = "de",
  br = "br"
}

export interface IAppPopup {
  isOpen: boolean;
  name: string;
  data: any | null;
}

export interface IAppState {
  popup: IAppPopup;
  currentLang: ELang;
  isRequestError: boolean;
  isFontLoad: boolean;
  isLangDetected: boolean;
  cookieOpen: boolean;
}
